<template>
  <ol class="breadcrumb page-breadcrumb">
    <li
      v-for="(item, index) in breadcrumbRouterItems"
      :key="'breadCrumb' + index"
      class="breadcrumb-item"
      :class="{ active: index === breadcrumbRouterItems.length - 1 }"
    >
      <i v-if="item.icon" class="fal fa-fw" :class="item.icon" />

      <router-link
        v-if="item.name && index !== breadcrumbRouterItems.length - 1"
        :to="{ name: item.name, params: {...$route.params, ...item.params}, query: {...$route.query, ...item.query} }"
      >
        {{ item.title }}
      </router-link>

      <a v-else>{{ item.title }}</a>
    </li>
  </ol>
</template>

<script>
import { mapState } from 'vuex';

import { mainRoute } from '@/router/main.route';
import { getBreadcrumbItems } from '@/utils/breadcrumb';
import { getMenuElements } from '@/utils/menu';

// @vuese
// Breadcrumb
// @group AppLayout
export default {
  name: 'Breadcrumb',
  computed: {
    ...mapState({
      appTitle: state => state.system.appTitle
    }),
    breadcrumbRouterItems() {
      const routes = getBreadcrumbItems(mainRoute.children).filter(x => x.route.name === this.$route.name);
      const route = routes.sort((a, b) => {
        if (!a.parents && !b.parents) {
          return 0;
        }
        if (!a.parents) {
          return -1;
        }
        if (!b.parents) {
          return 1;
        }
        return a.parents.length - b.parents.length;
      })[routes.length - 1];

      if (!route) {
        return undefined;
      }
      const home = { icon: 'fa-home', title: 'Home' };
      const parents = route.parents ? route.parents.map(parent => parent.route) : [];
      const crumbs = [home, ...parents, route.route].filter(item => item.title);
      const lastCrumb = crumbs[crumbs.length - 1];
      if (lastCrumb) {
        document.title = lastCrumb.title + ' - ' + this.appTitle;
        return crumbs;
      } else {
        document.title = this.appTitle;
      }
    }
  }
};
</script>

<style scoped>
.breadcrumb-item.active {
  font-weight: 600;
  text-decoration: none;
}

.breadcrumb-item {
  text-decoration: underline;
  cursor: pointer;
}
</style>
